// extracted by mini-css-extract-plugin
export default {"Photoslurp":"A45FqNw4jGyN2GEZTPgg"};